/* tslint:disable:no-console */
export function getLocale(cb?: (locale?: Locale) => void): void | string {
  let locale: Locale;

  if (typeof window === 'undefined') {
    if (cb) {
      cb();
    }

    return '';
  }

  if (window.navigator && window.navigator.language) {
    locale = window.navigator.language.split('-')[0] as Locale;
  } else {
    locale = 'en';
  }

  if (!cb) {
    return locale;
  }

  return cb(locale);
}

export function navigateObject<TranslationsType, TranslationsKeys>(
  path: TranslationsKeys,
  object: TranslationsType = {} as TranslationsType
): string {
  try {
    return (path as any).split('.').reduce((o: any, i: any) => o[i], object); // shit-allowed
  } catch (err) {
    console.error(err);
    return path as any;
  }
}

export function replaceArgs(
  str: string = '',
  args?: TranslatorMacroReplace
): string {
  if (!args) {
    return str;
  }

  return Object.keys(args).reduce((acc, arg) => {
    return acc.replace(new RegExp(`#{${arg}}`, 'g'), args[arg]);
  }, str);
}

export function createTranslator<TranslationsType, TranslationsKeys>(
  lang: Locale,
  defaultTranslations: TranslationsWithEn<TranslationsType>,
  customTranslations: Translations<TranslationsType> = {}
) {
  let translations: any;
  const defaultTranslation: TranslationsType = (defaultTranslations as any)[
    lang
  ];
  if (defaultTranslation) {
    translations = { ...defaultTranslation };
  } else {
    translations = { ...defaultTranslations.en };
  }

  // Override with custom translations
  const customTranslation: any = (customTranslations as any)[lang];
  if (customTranslation) {
    Object.keys(customTranslation).forEach(globalKey => {
      if (typeof customTranslation[globalKey] === 'object') {
        Object.keys(customTranslation[globalKey]).forEach(labelKey => {
          translations[globalKey][labelKey] =
            customTranslation[globalKey][labelKey];
        });
      } else {
        translations[globalKey] = customTranslation[globalKey];
      }
    });
  }

  return (path: TranslationsKeys, args?: TranslatorMacroReplace) => {
    const str = navigateObject<TranslationsType, TranslationsKeys>(
      path,
      translations
    );

    if (str && typeof str === 'string') {
      return replaceArgs(str, args);
    } else {
      return '';
    }
  };
}
